// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"StudentTabs__materialize-textarea___Md4uU","modal-2463794813":"StudentTabs__modal-2463794813___Y7p6j","container":"StudentTabs__container___2m-3W","activeClass":"StudentTabs__activeClass___2wPUe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StudentsTabs/StudentTabs.scss
// module id = 1540
// module chunks = 0